import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    SimpleChanges,
    OnChanges,
    ViewChild,
    OnDestroy
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MessageService } from "primeng/api";
import { Table } from "primeng/table";
import { Subject, takeUntil } from "rxjs";
import { AppMainService } from "src/app/app-main.service";
import { AppMainComponent } from "src/app/app.main.component";
import { JobFunction } from "src/app/configurations/fsm/territory/models/job-function.model";
import * as USER_MODULE_CONSTANT from "src/app/configurations/users/constant/users-module-name";
import { Profile } from "src/app/configurations/users/profile/models/profile.model";
import { UserProfileService } from "src/app/configurations/users/profile/services/profile.services";
import { RoleHierarchy } from "src/app/configurations/users/role-hierarchy/models/role-hierarchy.model";
import { RoleHierarchyService } from "src/app/configurations/users/role-hierarchy/services/role-hierarchy.service";
import { AssociatedUser } from "src/app/configurations/users/user/models/associated-user.model";
import { JobTypeService } from "src/app/configurations/users/user/services/job-type.services";
import { User } from "../../models/user.model";
import { SharedAssociatedUserService } from "../../services/associated-users.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-shared-associated-users",
    templateUrl: "./associated-users.component.html",
    styleUrls: ["./associated-users.component.css"],
})
export class SharedAssociatedUsers implements OnChanges, OnDestroy, OnInit {

    @ViewChild('associatedUserTable') associatedUserTable: Table;

    @Input() displayAssociatedUsersModal: boolean;
    @Input() associatedUsers: AssociatedUser[];
    @Input() associatedUsersFrom: string; // Sub Module Name under user
    @Input() associatedUsersSubModuleId: number; // Get the specific id of sub module's associated users
    @Input() selectedRoleHierarchyName: string;

    @Output() closeAssociatedUserModalOutputEvent = new EventEmitter();
    @Output() completedAddNewUser = new EventEmitter();

    /* Subject to unsubscribe */
    private ngUnsubscribe = new Subject<void>(); 

    defaultProfileImage = `${environment.assestsBasePath}layout/images/avatar5.png`;
    displayAddUserModal: boolean = false;
    addUserForm: FormGroup;
    users: User[] = [];
    subModuleId: number;
    jobTypeTransferForm: FormGroup;
    jobTypeTransferData: any; 
    displayTransferJobTypeModal: boolean = false;
    filteredJobTypes: JobFunction[] = [];
    selectedUser: any;

    displayTransferProfile: boolean = false;
    profileTransferForm: FormGroup;
    profileTransferData: any;
    filteredProfiles: Profile[] = [];

    displayRoleHierarchyTransferModal: boolean = false;
    roleHierarchyTransferForm: FormGroup;
    roleHierarchyTransferData: any;
    filteredRoleHierarchy: RoleHierarchy[] = [];

    constructor(
        private formBuilder: FormBuilder,
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private sharedAssociatedUserService: SharedAssociatedUserService,
        private jobTypeService: JobTypeService,
        private userProfileService: UserProfileService,
        private roleHierarchyService: RoleHierarchyService
    ) {
        this.prepareAddUserForm();
        this.prepreJobTypeTransferForm();
        this.prepreProfileTransferForm();
        this.prepreRoleHierachyTransferForm();
    }

    ngOnInit(): void {
        //this.prepareAddUserForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        
    }

    prepareAddUserForm(): void {
        this.addUserForm = this.formBuilder.group({
            newUser: ['', Validators.required]
        });
    }

    prepreJobTypeTransferForm(): void {
        this.jobTypeTransferForm = this.formBuilder.group({
            jobType: ['', Validators.required]
        });
    }

    prepreProfileTransferForm(): void {
        this.profileTransferForm = this.formBuilder.group({
            profile: ['', Validators.required]
        });
    }

    prepreRoleHierachyTransferForm(): void {
        this.roleHierarchyTransferForm = this.formBuilder.group({
            role: ['', Validators.required]
        });
    }

    addUserModal(): void {
        this.getSubModuleIdFromSubModuleName();
        this.displayAddUserModal = true;
        this.getDiassociatedUsers();
    }

    getDiassociatedUsers(): void {
        this.appMainService.isShowSpinner('getDiassociatedUsers');
        this.sharedAssociatedUserService.getDiassociatedUsers(this.subModuleId, this.associatedUsersSubModuleId)
        .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                  this.users = response;
                  this.appMainService.isHideSpinner('getDiassociatedUsers');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('getDiassociatedUsers');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'User lists are not loaded, please try again later..' 
                    });
                }),
                complete: (() => {
                })
          });
    }

    getSubModuleIdFromSubModuleName(): void {
        switch (this.associatedUsersFrom) {
            case USER_MODULE_CONSTANT.ROLE_HIERARCHY:
                this.subModuleId = USER_MODULE_CONSTANT.ROLE_HIERARCHY_ID;
                break;
            case USER_MODULE_CONSTANT.PROFILE:
                this.subModuleId = USER_MODULE_CONSTANT.RPROFILE_ID;
                break;
            case USER_MODULE_CONSTANT.JOB_TYPE:
                this.subModuleId = USER_MODULE_CONSTANT.JOB_TYPE_ID;
                break;
            default:
                this.messageService.add({ 
                    severity: 'error', 
                    summary: 'Error', 
                    detail: 'Sub module name is not found..' 
                  });
                break;
        }
    }

    closeAssociatedUserModal(): void {
        this.associatedUserTable.reset();
        this.associatedUsers = [];
        this.closeAssociatedUserModalOutputEvent.emit();
    }

    deleteUser(data): void {
        this.getSubModuleIdFromSubModuleName();
        this.selectedUser = data;
        if (this.subModuleId == USER_MODULE_CONSTANT.JOB_TYPE_ID){
            this.displayTransferJobTypeModal = true;
            this.getJobTypes();
        }
        else if (this.subModuleId == USER_MODULE_CONSTANT.RPROFILE_ID){
            this.displayTransferProfile = true;
            this.getProfileList();
        }
        else if (this.subModuleId == USER_MODULE_CONSTANT.ROLE_HIERARCHY_ID){
            this.getRoleHierarchyList();
        }
    }

    getJobTypes(): void {
        this.appMainService.isShowSpinner('getJobTypes');
        this.jobTypeService.getJobTypes()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                      const data = response;
                      this.jobTypeTransferData = data.find((obj) => obj.id == this.associatedUsersSubModuleId);
                      this.filteredJobTypes = data.filter(obj => obj?.id != this.associatedUsersSubModuleId);
                      this.appMainService.isHideSpinner('getJobTypes');
                    },
                    error: ((error) => {
                        this.appMainService.isHideSpinner('getJobTypes');
                        this.messageService.add({ severity: 'error', summary: 'Error', detail: error?.error?.Message ? error?.error?.Message : 'Job Types are not loaded..' });
                    }),
                    complete: (() => {
                    })
                });
    }

    getProfileList(): void {
        this.appMainService.isShowSpinner('getProfileList');
        this.userProfileService.getAllProfile()
                .pipe(takeUntil(this.ngUnsubscribe))
                .subscribe({
                    next: (response) => {
                        const data = response;
                        this.profileTransferData = data.find((obj) => obj.id == this.associatedUsersSubModuleId);
                        this.filteredProfiles = data.filter(obj => obj?.id != this.associatedUsersSubModuleId);
                        this.appMainService.isHideSpinner('getProfileList');
                    },
                    error: ((error) => {
                        this.appMainService.isHideSpinner('getProfileList');
                        this.messageService.add({ 
                          severity: 'error', 
                          summary: 'Error', 
                          detail: error?.error?.Message ? error?.error?.Message : 'Profile lists are not loaded, please try again later..' 
                        });
                    }),
                    complete: (() => {
                    })
                });
      }

      getRoleHierarchyList(): void {
        this.appMainService.isShowSpinner("getRoleHierarchyList");
        this.roleHierarchyService
            .getAllRoleHierarchy()
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.filteredRoleHierarchy = [];
                    const data = response;
                    const convertedData = this.convertJsonForTreeSelect(data);
                    //const filteredRoles = this.removeRolesById(convertedData, this.associatedUsersSubModuleId);
                    this.filteredRoleHierarchy = convertedData;
                    //console.log(this.filteredRoleHierarchy);
                    this.displayRoleHierarchyTransferModal = true;
                    this.appMainService.isHideSpinner("getRoleHierarchyList");
                },
                error: (error) => {
                    this.appMainService.isHideSpinner("getRoleHierarchyList");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: error?.error?.Message
                            ? error?.error?.Message
                            : "Role lists are not loaded, please try again later..",
                    });
                },
                complete: () => {},
            });
    }

    convertJsonForTreeSelect(inputJson) {
        return inputJson.map((item) => ({
            ...item,
            label: item.roleName,
            children: this.convertJsonForTreeSelect(item.childRoleDTO),
        }));
    }

    removeRolesById(roles, id) {
        for (let i = 0; i < roles.length; i++) {
            const role = roles[i];
            if (role.id === id) {
                roles.splice(i, 1);
                return roles;
            } else if (role.children && role.children.length > 0) {
                const childResult = this.removeRolesById(role.children, id);
                role.children = childResult;
                if (childResult.length === 0) {
                    roles.splice(i, 1);
                    i--;
                }
            }
        }
        return roles;
      }
      

    AddNewUser(): void {
        const userData = {
            userId: this.addUserForm.value['newUser']?.userId
        }
        this.appMainService.isShowSpinner('AddNewUser');
        this.sharedAssociatedUserService.addNewUser(this.subModuleId, this.associatedUsersSubModuleId, userData)
        .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.completedAddNewUser.emit();
                    this.appMainService.isHideSpinner('AddNewUser');
                    this.displayAddUserModal = false;
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('AddNewUser');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Error occurd, please try again later..' 
                    });
                }),
                complete: (() => {
                })
          });
    }

    closeAddUserModal(): void {
        this.addUserForm.reset();
        this.displayAddUserModal = false;
    }

    closeTransferJobTypeModal(): void {
        this.jobTypeTransferForm.reset();
        this.displayTransferJobTypeModal = false;
    }

    transferAndDeleteJobType(): void {
        const jobTypeData = {
            userId: this.selectedUser?.userId
        }
        const transferId = this.jobTypeTransferForm.value['jobType']?.id;
        this.appMainService.isShowSpinner('transferAndDeleteJobType');
        this.sharedAssociatedUserService.transferAndDelete(this.subModuleId, transferId, jobTypeData)
        .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.displayTransferJobTypeModal = false;
                    this.completedAddNewUser.emit();
                    this.appMainService.isHideSpinner('transferAndDeleteJobType');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('transferAndDeleteJobType');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Error occurd, please try again later..' 
                    });
                }),
                complete: (() => {
                })
          });
    }

    closeTransferProfileModal(): void {
        this.profileTransferForm.reset();
        this.displayTransferProfile = false;
    }

    transferAndDeleteProfile(): void {
        const profileData = {
            userId: this.selectedUser?.userId
        }
        const transferId = this.profileTransferForm.value['profile']?.id;
        this.appMainService.isShowSpinner('transferAndDeleteProfile');
        this.sharedAssociatedUserService.transferAndDelete(this.subModuleId, transferId, profileData)
        .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.displayTransferProfile = false;
                    this.completedAddNewUser.emit();
                    this.appMainService.isHideSpinner('transferAndDeleteProfile');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('transferAndDeleteProfile');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Error occurd, please try again later..' 
                    });
                }),
                complete: (() => {
                })
          });
    }

    closeRoleHierarchyTransferModal(): void {
        this.roleHierarchyTransferForm.reset();
        this.displayRoleHierarchyTransferModal = false;
    }

    transferAndDeleteRoleHierarchy(): void {
        const roleData = {
            userId: this.selectedUser?.userId
        }
        const transferId = this.roleHierarchyTransferForm.value['role']?.id
        this.appMainService.isShowSpinner('transferAndDeleteRoleHierarchy');
        this.sharedAssociatedUserService.transferAndDelete(this.subModuleId, transferId, roleData)
        .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe({
                next: (response) => {
                    this.displayRoleHierarchyTransferModal = false;
                    this.completedAddNewUser.emit();
                    this.appMainService.isHideSpinner('transferAndDeleteRoleHierarchy');
                },
                error: ((error) => {
                    this.appMainService.isHideSpinner('transferAndDeleteRoleHierarchy');
                    this.messageService.add({ 
                      severity: 'error', 
                      summary: 'Error', 
                      detail: error?.error?.Message ? error?.error?.Message : 'Error occurd, please try again later..' 
                    });
                }),
                complete: (() => {
                })
          });
    }

    get newUser() { return this.addUserForm.get('newUser'); }
    get jobType() { return this.jobTypeTransferForm.get('jobType'); }
    get profile() { return this.profileTransferForm.get('profile'); }
    get role() { return this.roleHierarchyTransferForm.get('role'); }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
